import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import SketchPage from './pages/SketchPage/SketchPage';
import ProjectsPage from './pages/ProjectsPage/ProjectsPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<ProjectsPage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/sketch" element={<SketchPage />} />
            <Route path="/floor" element={<SketchPage />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
